// ========================================================
// INTERCEPT & RE-DISPATCH: Shopify cart/add.json & cart/change.json
// ========================================================
// ;(function() {
//   const originalFetch = window.fetch;
//   window.fetch = function(resource, config) {
//     // figure out the URL string
//     const url = resource instanceof Request ? resource.url : resource;
//     const method = (config && config.method) || (resource instanceof Request && resource.method) || 'GET';

//     return originalFetch(resource, config).then((response) => {
//       // Only fire on the two cart endpoints AND if it is a POST
//       if (
//         method.toUpperCase() === 'POST' &&
//         (
//           url.includes('/cart/add.js')   ||
//           url.includes(theme.routes.cart_add_url)   ||
//           url.includes('/cart/change.js')||
//           url.includes(theme.routes.cart_change_url)
//         )
//       ) {
//         // clone so we don’t consume the body
//         response.clone()
//           .json()
//           .then((cartJson) => {
//             // re-dispatch exactly as your cart.js does
//             document.dispatchEvent(
//               new CustomEvent('cart:updated', { detail: { cart: JSON.stringify(cartJson) } })
//             );
//           })
//           .catch(() => {
//             // if it wasn’t JSON, ignore
//           });
//       }
//       return response;
//     });
//   };
// })();


document.addEventListener("DOMContentLoaded", function () {
  // Set the countdown duration in days (e.g. 2 days)
  var countdownDurationInDays = 2;

  // Function to start/restart countdown
  function startCountdown() {
    var countdownDurationMs = countdownDurationInDays * 24 * 60 * 60 * 1000;
    var countdownEndTime = new Date().getTime() + countdownDurationMs;

    var countdownInterval = setInterval(function () {
      var now = new Date().getTime();
      var distance = countdownEndTime - now;

      if (distance < 0) {
        clearInterval(countdownInterval);
        startCountdown(); // restart countdown when it ends
        return;
      }

      var d = Math.floor(distance / (1000 * 60 * 60 * 24));
      var h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var s = Math.floor((distance % (1000 * 60)) / 1000);

      var timerElement = document.getElementById("sidebar-countdown-timer");
      if (timerElement) {
        timerElement.innerHTML = `${d}d ${h}h ${m}m ${s}s`;
      }
    }, 1000);
  }

  // startCountdown();
});

class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

// ———————————————————————————————————————————————————————————————
//  OPEN ON ANY CART UPDATE (with debug logs)
// ———————————————————————————————————————————————————————————————
customElements.whenDefined('mini-cart').then(() => {
  console.log('[drawer] mini-cart defined, attaching cart:updated listener');
  
  document.addEventListener('cart:updated', (e) => {
    console.log('[drawer] ▶ cart:updated event received', e.detail);

    const mini = document.querySelector('mini-cart');
    if (mini) {
      mini.open();
      console.log('[drawer] ✅ mini-cart.open() called');
    } else {
      console.warn('[drawer] ❌ <mini-cart> element not found');
    }
  });
});

